function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__a",
  x1: "0%",
  x2: "100%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__b",
  x1: "42.696%",
  x2: "57.146%",
  y1: "99.166%",
  y2: ".587%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__c",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__d",
  x1: "58.129%",
  x2: "41.903%",
  y1: "98.77%",
  y2: "1.235%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__e",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__f",
  x1: "49.981%",
  x2: "49.981%",
  y1: "100%",
  y2: "-.009%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__g",
  x1: "50%",
  x2: "50%",
  y1: "99.994%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "gray",
  stopOpacity: 0.1
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "translate(0 -1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__a)",
  d: "M-10.964 31.698L154.807 31.776 154.864 152.12 -10.907 152.041z",
  opacity: 0.5,
  transform: "rotate(-81.42 132.95 21.015)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M112.756 32.795L275.204 32.837 275.234 150.201 112.786 150.159z",
  transform: "rotate(-81.42 193.995 91.498)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M152.177 80.722L236.883 80.7 236.882 85.826 152.176 85.848z",
  transform: "rotate(8.58 194.53 83.274)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M150.262 93.39L234.969 93.368 234.967 98.494 150.261 98.515z",
  transform: "rotate(8.58 192.615 95.942)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M199.143 43.232L242.78 43.221 242.779 48.347 199.141 48.358z",
  transform: "rotate(8.58 220.96 45.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M201.08 55.902L237.017 55.893 237.016 61.019 201.078 61.028z",
  transform: "rotate(8.58 219.048 58.46)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M148.403 105.294L222.844 105.275 222.843 110.401 148.402 110.42z",
  transform: "rotate(8.58 185.623 107.847)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M146.544 117.198L210.716 117.181 210.715 122.307 146.543 122.324z",
  transform: "rotate(8.58 178.63 119.752)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M144.672 129.292L201.144 129.278 201.143 134.404 144.671 134.418z",
  transform: "rotate(8.58 172.908 131.848)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M142.672 143.111L214.544 143.093 214.543 148.218 142.671 148.237z",
  transform: "rotate(8.58 178.607 145.665)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M141.003 152.524L169.237 152.517 169.236 157.643 141.002 157.65z",
  transform: "rotate(8.58 155.12 155.083)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__b)",
  d: "M33.768 19.935c1.205-8.086-3.4-15.907-11.002-18.688-7.603-2.78-16.088.254-20.274 7.25-4.186 6.995-2.908 16.007 3.053 21.53v.076c.468.617 1.052 1.135 1.718 1.522l.033-.073c.683.8 3.828 2.395 7.628 2.964h.084c2.407.371 5.082.338 7.564-.569 0 0 .027-.043.073-.122.623-.188 1.212-.477 1.745-.855l.054-.189c5.007-2.47 8.494-7.274 9.324-12.846z",
  opacity: 0.5,
  transform: "translate(158 27)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 174.572,
  cy: 43.802,
  fill: "#F5F5F5",
  rx: 16.592,
  ry: 16.619,
  transform: "rotate(-81.42 174.572 43.802)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDA57D",
  d: "M166.996 50.001s-3.944-.255-3.996 6.615c.458.562 1.03 1.032 1.68 1.384l3.32-6.712L166.996 50zM179.455 51s4.123.933 1.874 8.067c-.655.446-1.395.763-2.178.933L178 52.038 179.455 51z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M169.529 38s-2.613 5.215-3.529 4.543c0 0 8.314 10.094 18 2.825-.753-1.965-1.73-3.829-2.91-5.551L169.53 38z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 175.308,
  cy: 38.072,
  fill: "#333",
  rx: 7.354,
  ry: 7.366,
  transform: "rotate(-81.42 175.308 38.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M179.234 51.83L166.537 50l-1.95 4.686s-1.051 2.148-.34 3.263c.71 1.116 8.44 4.53 14.883 2.325.723-1.221 1.007-2.635.808-4.024-.319-2.365-.142-.186-.142-.186l-.562-4.234z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M180.23 51.83L167.535 50l-1.947 4.685s-1.051 2.147-.34 3.263c.71 1.116 8.44 4.531 14.883 2.325.723-1.22 1.007-2.635.808-4.025-.319-2.365-.142-.186-.142-.186l-.565-4.231z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDD835",
  d: "M179.234 51.83L166.537 50l-1.95 4.686s-1.051 2.148-.34 3.263c.71 1.116 8.44 4.53 14.883 2.325.723-1.221 1.007-2.635.808-4.024-.319-2.365-.142-.186-.142-.186l-.562-4.234z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M171.526 45.66l5.083.767-.692 4.579c-.168 1.115-1.21 1.883-2.328 1.715l-1.04-.157c-1.117-.168-1.886-1.209-1.718-2.324l.692-4.58h.003z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDA57D",
  d: "M171.551 45.473l5.083.765-.692 4.58c-.169 1.115-1.21 1.883-2.328 1.715l-1.037-.157c-1.118-.168-1.887-1.209-1.718-2.324l.692-4.58z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M172 45.79c1.493 1.116 3.235 1.475 4.909 1.014l.091-.81-4.912-.994-.088.79z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 175.07,
  cy: 39.649,
  fill: "#FDA57D",
  rx: 7.354,
  ry: 7.366,
  transform: "rotate(-81.42 175.07 39.65)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M168 35.99L182 38s-.343-5.542-5.689-5.97c-5.346-.43-8.311 3.96-8.311 3.96z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 167.982,
  cy: 38.262,
  fill: "#FDA57D",
  rx: 1.284,
  ry: 1,
  transform: "rotate(-81.42 167.982 38.262)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 182.213,
  cy: 40.407,
  fill: "#FDA57D",
  rx: 1.284,
  ry: 1,
  transform: "rotate(-81.42 182.213 40.407)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M168 35.99L182 38s-.343-5.542-5.689-5.97c-5.346-.43-8.311 3.96-8.311 3.96z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__c)",
  d: "M12.603 8.766L133.19 8.791 133.225 175.193 12.638 175.168z",
  opacity: 0.5,
  transform: "rotate(-9.181 222.378 103.98)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M14.083 33.955L131.446 33.988 131.49 196.437 14.127 196.404z",
  transform: "rotate(-9.31 72.786 115.196)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M28.431 104.617L113.137 104.64 113.138 109.766 28.433 109.742z",
  transform: "rotate(-9.31 70.785 107.191)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M30.507 117.261L115.213 117.285 115.215 122.41 30.509 122.387z",
  transform: "rotate(-9.31 72.861 119.836)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M62.589 60.846L106.226 60.858 106.227 65.984 62.59 65.971z",
  transform: "rotate(-9.31 84.408 63.415)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M68.514 73.492L104.451 73.501 104.452 78.627 68.515 78.618z",
  transform: "rotate(-9.31 86.483 76.06)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M32.651 130.736L107.091 130.756 107.093 135.882 32.653 135.862z",
  transform: "rotate(-9.31 69.872 133.309)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M34.794 144.208L98.966 144.225 98.967 149.351 34.796 149.334z",
  transform: "rotate(-9.31 66.88 146.78)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M36.921 157.477L93.393 157.492 93.394 162.618 36.923 162.603z",
  transform: "rotate(-9.31 65.158 160.048)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M38.897 168.873L110.768 168.892 110.77 174.018 38.898 173.998z",
  transform: "rotate(-9.31 74.833 171.445)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M41.262 185.048L69.496 185.056 69.497 190.182 41.263 190.174z",
  transform: "rotate(-9.31 55.38 187.615)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__d)",
  d: "M35.705 15.09C34.329 6.773 27.225.577 18.73.285c-8.493-.293-16.014 5.4-17.969 13.6-1.954 8.2 2.2 16.629 9.927 20.137l.025.076c.665.453 1.414.77 2.203.934v-.082c.938.567 4.594 1.125 8.578.466h.087c2.526-.405 5.19-1.296 7.384-2.98 0 0 0-.05.03-.14.565-.385 1.063-.857 1.475-1.398v-.201c4.23-4.03 6.189-9.869 5.234-15.609z",
  opacity: 0.5,
  transform: "translate(23 57)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 41.003,
  cy: 75.295,
  fill: "#F5F5F5",
  rx: 17.084,
  ry: 17.056,
  transform: "rotate(-9.31 41.003 75.295)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4D8AF0",
  d: "M34.513 83s-4.147.983-1.786 8.092c.668.44 1.422.748 2.217.908L36 84.02 34.513 83zM47.974 81.002S51.87 80.66 52 88.425c-.445.637-1.001 1.172-1.638 1.575L47 82.46l.974-1.458z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 39.36,
  cy: 69.494,
  fill: "#333",
  rx: 7.572,
  ry: 7.56,
  transform: "rotate(-9.31 39.36 69.494)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4D8AF0",
  d: "M47.23 81l-12.834 2.162-.356 5.501s-.299 2.573.734 3.503c1.032.93 9.613 2.002 15.087-2.372.3-1.502.113-3.063-.53-4.445-1.078-2.357-.2-.148-.2-.148L47.23 81z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4D8AF0",
  d: "M48.23 81l-12.834 2.162-.356 5.501s-.299 2.573.734 3.503c1.032.93 9.613 2.002 15.087-2.372.3-1.502.113-3.063-.53-4.445-1.078-2.357-.2-.148-.2-.148L48.23 81z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4D8AF0",
  d: "M48.23 81l-12.834 2.16-.356 5.507s-.299 2.57.734 3.5c1.032.929 9.613 2 15.087-2.37.3-1.501.113-3.061-.53-4.442-1.078-2.355-.2-.148-.2-.148L48.23 81z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M38.077 78.099l5.214-.853.78 4.752c.183 1.113-.572 2.164-1.687 2.346l-1.18.193c-1.115.183-2.167-.572-2.35-1.685l-.78-4.753h.003z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDA57D",
  d: "M38.046 77.906l5.214-.853.78 4.752c.183 1.114-.573 2.164-1.688 2.346l-1.179.193c-1.115.183-2.167-.572-2.35-1.685l-.78-4.753h.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M38.097 78.822c1.676.434 3.416.068 4.903-1.033L42.9 77 38 78.055l.097.767z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 39.629,
  cy: 71.114,
  fill: "#FDA57D",
  rx: 7.572,
  ry: 7.56,
  transform: "rotate(-9.31 39.629 71.114)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M32 70l14-2.395s-2.123-5.701-7.354-4.416C33.416 64.474 32 70 32 70z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M32 70l14-2.397s-2.121-5.699-7.348-4.414C33.426 64.473 32 70 32 70z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 32.348,
  cy: 72.436,
  fill: "#FDA57D",
  rx: 1,
  ry: 1.324,
  transform: "rotate(-9.181 32.348 72.436)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 46.855,
  cy: 69.602,
  fill: "#FDA57D",
  rx: 1,
  ry: 1.32,
  transform: "rotate(-9.31 46.855 69.602)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__e)",
  d: "M0.192 0.142H120.93599999999999V165.951H0.192z",
  opacity: 0.5,
  transform: "translate(86 51)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M88 53H205V215H88z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#prefix__f)",
  d: "M.07 17.991C.07 9.519 6.102 2.225 14.48.565c8.377-1.66 16.772 2.775 20.055 10.597 3.284 7.82.544 16.853-6.546 21.58v.078c-.585.557-1.276.994-2.033 1.284l-.024-.078c-.838.714-4.371 1.857-8.431 1.845h-.088c-2.571 0-5.36-.45-7.817-1.767 0 0-.021-.048-.054-.135-.623-.29-1.194-.678-1.692-1.149l-.027-.201C2.968 29.306.07 23.835.07 17.991z",
  opacity: 0.5,
  transform: "translate(103 72)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121.5,
  cy: 89.5,
  r: 17.5,
  fill: "#F5F5F5"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BE7C5E",
  d: "M114.6 96s-4.615.33-3.395 7.766c.634.535 1.38.955 2.199 1.234L116 97.246 114.6 96zM128.114 96s3.7.33 2.721 7.766c-.507.535-1.106.955-1.762 1.234L127 97.222 128.114 96z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M114.15 84s-.323.958-.786 2.066c-1.005 2.423.142 11.73 2.547 12.723 2.698 1.115 6.247 1.826 9.932.465 3.204-1.183 4.19-11.777 1.927-14.358-.265-.312-.542-.603-.832-.896H114.15z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121.5,
  cy: 83.5,
  r: 7.5,
  fill: "#333"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M128.253 96h-13.688l-1.279 5.44s-.752 2.52.182 3.63c.933 1.108 9.653 3.627 16.06.18.56-1.451.623-3.044.183-4.535-.73-2.538-.182-.18-.182-.18L128.253 96z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M128.26 96h-13.695l-1.279 5.44s-.752 2.52.182 3.63c.933 1.108 9.653 3.627 16.06.18.56-1.451.623-3.044.183-4.535-.73-2.538-.182-.18-.182-.18L128.259 96z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3AD29F",
  d: "M128.253 96h-13.688l-1.279 5.44s-.752 2.52.182 3.63c.933 1.108 9.653 3.627 16.06.18.56-1.451.623-3.044.183-4.535-.73-2.538-.182-.18-.182-.18L128.253 96z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M119.003 92H124v4.961c0 1.126-.847 2.039-1.893 2.039h-1.214c-.502 0-.984-.215-1.339-.597s-.554-.9-.554-1.442V92h.003z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BE7C5E",
  d: "M119.003 92H124v4.961c0 1.126-.847 2.039-1.893 2.039h-1.214c-.502 0-.984-.215-1.339-.597s-.554-.9-.554-1.442V92h.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M119 92.578c1.613.563 3.387.563 5 0V92h-5v.578z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 121.5,
  cy: 84.5,
  r: 7.5,
  fill: "#BE7C5E"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M114 82h15s-1.281-6.392-6.95-5.981C116.38 76.429 114 82 114 82z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 113.5,
  cy: 84.5,
  fill: "#BE7C5E",
  rx: 1,
  ry: 1.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 128.5,
  cy: 84.5,
  fill: "#BE7C5E",
  rx: 1,
  ry: 1.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M114 82h15s-1.281-6.392-6.95-5.981C116.38 76.429 114 82 114 82z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M103 123H188V128H103zM103 136H188V141H103zM144 82H188V87H144z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M148 95H184V100H148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E0E0E0",
  d: "M103 149H177V154H103zM103 161H167V166H103zM103 174H159V179H103zM103 187H175V192H103z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6C63FF",
  d: "M103 200H131V205H103z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 26.021,
  cy: 25.518,
  fill: "url(#prefix__g)",
  opacity: 0.5,
  rx: 25.813,
  ry: 25.467,
  transform: "translate(172 177)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 198,
  cy: 202,
  r: 24,
  fill: "#07C63C"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M187.75 199.399L196.749 207.571 209.498 189 214 192.715 196.749 215 184 200.886z"
}));

var SvgPersonaCv = function SvgPersonaCv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 227,
    viewBox: "0 0 266 227",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonaCv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/persona-cv.10194269.svg";
export { ForwardRef as ReactComponent };